import { forwardRef } from 'react';
import type { Ref } from 'react';

import FormLabel from './FormLabel';
import PasswordInput from './PasswordInput';
import type { PasswordInputProps } from './PasswordInput';

/**
 * Wraps a PasswordInput with a label. Displays the label above the <input />, with optional required text.
 */
const LabeledPasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({
  label,
  isRequired,
  ...textInputProps
}: PasswordInputProps, ref: Ref<HTMLInputElement>) => (
  <FormLabel
    label={label}
    requiredText={isRequired ? '(Required)' : undefined}
    variant="legacy"
  >
    <PasswordInput
      ref={ref}
      label={label}
      isRequired={isRequired}
      // We want to inject a large number of unknown props here, so spreading is necessary.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...textInputProps}
    />
  </FormLabel>
));

export default LabeledPasswordInput;
